<template>
  <div :id="elementID" />
</template>

<script>
import Highcharts from "highcharts/highcharts.js";
import moment from "moment";

export default {
  name: "line_chart",
  props: {
    series: Object,
    el: {
      type: String,
      default: function () {
        return "lincechart-element";
      },
    },
    mode: {
      type: String,
      default: function () {
        return "single";
      },
    },
    height: {
      type: [Number, String],
      default: function () {
        return 300;
      },
    },
    event: {
      type: Object,
      default: function () {
        return {};
      },
    },
    is_engagement_reach: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: this.series,
      elementID: this.el,
    };
  },
  methods: {
    loadChart: function (data, el, mode, height) {
      let self = this;

      var config = {
        chart: {
          type: "spline",
          backgroundColor: "transparent",
          height: height,
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "",
        },
        xAxis: [
          {
            categories: data.x,
            crosshair: true,
          },
        ],
        yAxis: [
          {
            labels: {
              formatter: function () {
                if (this.value > 1000000)
                  return Highcharts.numberFormat(this.value / 1000000, 0) + "M";
                else if (this.value > 1000)
                  return Highcharts.numberFormat(this.value / 1000, 0) + "K";
                return Highcharts.numberFormat(this.value, 0);
              },
            },
            title: {
              text: data.yName ? data.yName : "",
            },
          },
        ],
        tooltip: {
          shared: true,
        },
        legend: {
          layout: "horizontal",
          align: "center",
          verticalAlign: "bottom",
          maxHeight: 100,
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
            point: {
              events: {
                click: function () {
                  let start = "";
                  let end = "";
                  let params = {};
                  let tgl = this.category.split(" ");
                  let tgl_str = tgl[2] + "-" + tgl[1] + "-" + tgl[0];
                  tgl = moment(tgl_str, "YYYY-MMM-DD");
                  if (tgl.isValid()) {
                    start = tgl.format("YYYY-MM-DD 00:00:00");
                    end = tgl.format("YYYY-MM-DD 23:59:59");
                  } else {
                    start = moment(self.$route.query.from).format(
                      "YYYY-MM-DD HH:mm:ss"
                    );
                    end = moment(self.$route.query.to).format(
                      "YYYY-MM-DD HH:mm:ss"
                    );
                  }

                  params = {
                    from: start,
                    to: end,
                  };

                  if ("topic_selected" in self.$route.query) {
                    params.topic_selected = self.$route.query.topic_selected;
                  }
                  if ("cakupan" in self.$route.query) {
                    params.cakupan = self.$route.query.cakupan;
                  }

                  self.$router.push({ path: "/posts", query: params });
                },
              },
            },
          },
        },
        series: data.y,
      };
      if (mode == "dual") {
        var yAxis = [
          {
            title: {
              text: this.is_engagement_reach
                ? data.y[0].name
                : "yAxis" in data
                ? data.yAxis[0]
                  ? data.yAxis[0]
                  : "Jumlah"
                : "Jumlah",
            },
            labels: {
              formatter: function () {
                if (this.value > 1000000)
                  return Highcharts.numberFormat(this.value / 1000000, 0) + "M";
                else if (this.value > 1000)
                  return Highcharts.numberFormat(this.value / 1000, 0) + "K";
                return Highcharts.numberFormat(this.value, 0);
              },
            },
          },
          {
            title: {
              text: this.is_engagement_reach
                ? data.y[0].name
                : "yAxis" in data
                ? data.yAxis[1]
                  ? data.yAxis[1]
                  : "Jumlah"
                : "Jumlah",
            },
            labels: {
              formatter: function () {
                if (this.value > 1000000)
                  return Highcharts.numberFormat(this.value / 1000000, 0) + "M";
                else if (this.value > 1000)
                  return Highcharts.numberFormat(this.value / 1000, 0) + "K";
                return Highcharts.numberFormat(this.value, 0);
              },
            },
            opposite: true,
          },
        ];

        if (this.is_engagement_reach) {
          var line_chart_event = {
            events: {
              legendItemClick: function () {
                if (this.name != "Mentions") {
                  this.chart.yAxis[1].axisTitle.attr({
                    text: this.name,
                  });
                }
                var series = this.chart.series;
                for (var i = 0; i < series.length; i++) {
                  if (
                    series[i].index != this.index &&
                    series[i].name != "Mentions"
                  ) {
                    series[i].hide();
                  }
                }
              },
            },
          };
          config.plotOptions.line = line_chart_event;
        }

        config.yAxis = yAxis;
      }
      if (Object.keys(this.event).length > 0) {
        config.plotOptions.series.point.events = this.event;
      }
      new Highcharts.chart(el, config);
    },
  },
  mounted: function () {
    if (this.data != null) {
      if (Object.keys(this.data).length !== 0) {
        this.loadChart(this.data, this.elementID, this.mode, this.height);
      }
    }
  },
};
</script>